import React from 'react';
import PropTypes from 'prop-types';

const MobileHeaderContext = React.createContext(undefined);

function MobileHeaderProvider({ children }) {
  const headerRef = React.useRef();
  const [value] = React.useState({ headerRef });

  return (
    <MobileHeaderContext.Provider value={value}>
      {children}
    </MobileHeaderContext.Provider>
  );
}

function useMobileHeader() {
  const context = React.useContext(MobileHeaderContext);

  if (context === undefined) {
    throw new Error('useMobileHeader must be used within a MobileHeaderProvider');
  }

  return context;
}

MobileHeaderProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  MobileHeaderProvider,
  useMobileHeader,
};
